class RowspanMarker {
  constructor(config = {}) {
    const {
      tableSelector = 'table',
      className = 'has-rowspan',
      minSpan = 2
    } = config;

    this.tableSelector = tableSelector;
    this.className = className;
    this.minSpan = minSpan;

    this.tables = Array.from(document.querySelectorAll(this.tableSelector));

    if (this.tables.length > 0) {
      this.addRowspanClasses();
    }
  }

  addRowspanClasses() {
    this.tables.forEach((table) => {
      const rows = Array.from(table.querySelectorAll('tr'));
      let rowspanGroupCounter = 1;
      const groupMap = new Map();
      const rowGroups = new Map();

      rows.forEach((row, rowIndex) => {
        const cellsWithRowspan = Array.from(row.querySelectorAll('th[rowspan], td[rowspan]'));
        const spanValues = cellsWithRowspan
          .map((cell) => parseInt(cell.getAttribute('rowspan'), 10))
          .filter((value) => !Number.isNaN(value) && value >= this.minSpan);

        spanValues.forEach((spanValue) => {
          const affectedRows = rows.slice(rowIndex, rowIndex + spanValue);

          affectedRows.forEach((affectedRow) => {
            affectedRow.classList.add(this.className);
            affectedRow.classList.add(`${this.className}--${rowspanGroupCounter}`);

            if (!rowGroups.has(affectedRow)) {
              rowGroups.set(affectedRow, new Set());
            }
            rowGroups.get(affectedRow).add(rowspanGroupCounter);
          });

          groupMap.set(rowspanGroupCounter, affectedRows);

          row.classList.add(`${this.className}--${spanValue}`);

          rowspanGroupCounter += 1;
        });
      });

      rows.forEach((row) => {
        const groups = rowGroups.get(row);
        if (!groups || groups.size === 0) return;

        const groupIds = Array.from(groups);
        const hoverClass = `${this.className}--hover`;

        const addHover = () => {
          groupIds.forEach((groupId) => {
            const members = groupMap.get(groupId);
            if (members) {
              members.forEach((memberRow) => memberRow.classList.add(hoverClass));
            }
          });
        };

        const removeHover = () => {
          groupIds.forEach((groupId) => {
            const members = groupMap.get(groupId);
            if (members) {
              members.forEach((memberRow) => memberRow.classList.remove(hoverClass));
            }
          });
        };

        row.addEventListener('mouseenter', addHover);
        row.addEventListener('mouseleave', removeHover);
      });
    });
  }
}

export default RowspanMarker;

